import React, { Component } from "react";
import swal from 'sweetalert';
import { id_camaba } from "../../../config/utils";
import { API_AKADEMIK, API_MHS } from "../../../services/key/api";
import { KEY_AKA, KEY_MHS } from "../../../services/key/api_key";
import $ from 'jquery';

class SemesterPendek extends Component {

  state = {
    vmhs: '',
    matkulBawah: [],
    matkulAtas: [],
    checkAtas: [],
    checkBawah: []
  }

  getDataMhs = async () => {
    const dataMhs = await API_MHS.get('tampil/mhs/pengajuan/sp/view' + KEY_MHS + '&icmb=' + id_camaba)
    const dataAkdm = await API_AKADEMIK.get('view/datakdm/di/peng/sp/view' + KEY_AKA + '&icmb=' + id_camaba + '&tangmh=' + dataMhs.data[0].tangmh + '&jurmh=' + dataMhs.data[0].jurmh)
    this.setState({
      vmhs: {
        ...dataMhs.data[0],
        ...dataAkdm.data[0]
      }
    }, () => {
      this.getAkses();
    })
  }

  getAkses = () => {
    API_AKADEMIK.get('akses/pengajuan/sp/view' + KEY_AKA + '&tangmh=' + this.state.vmhs.tangmh)
      .then(res => {
        this.setState({
          akses: res.data[0].validasi
        }, () => {
          this.getMatkul();
        })
      })
  }

  getMatkul = async () => {
    if (this.state.akses == 1) {
      const matkulBawah = await API_AKADEMIK.get('tampil/tbl/bawah/matkul/sp/v' + KEY_AKA + '&idcmb=' + id_camaba)
      const matkulAtas = await API_AKADEMIK.get('tampil/tbl/atas/sp/view' + KEY_AKA + '&idcmb=' + id_camaba + '&idsem=' + this.state.vmhs.idsem)
      let filterMatkul = []
      if (matkulAtas.data.length != 0) {
        for (var m = 0; m < matkulAtas.data.length; m++) {
          var findIndex = matkulBawah.data.findIndex(x => x.kodemk == matkulAtas.data[m].kodemk)
          matkulBawah.data.splice(findIndex, 1)
          filterMatkul = matkulBawah.data
        }
      }
      this.setState({
        matkulBawah: filterMatkul.length == 0 ? matkulBawah.data : filterMatkul,
        matkulAtas: matkulAtas.data
      })
    }
  }

  toggleCheckboxAtas = (event) => {
    // check_list
    if (event.target.checked) {
      this.state.checkAtas.push(event.target.value)
    } else {
      var index = this.state.checkAtas.indexOf(event.target.value);
      this.state.checkAtas.splice(index, 1);
    }
  }

  toggleCheckboxBawah = (event) => {
    if (event.target.checked) {
      this.state.checkBawah.push(event.target.value)
    } else {
      var index = this.state.checkBawah.indexOf(event.target.value);
      this.state.checkBawah.splice(index, 1);
    }
  }

  ProcessPengajuan = () => {
    if (this.state.checkBawah.length != 0) {
      swal({
        title: "Yakin untuk diajukan ?",
        text: "mata kuliah akan diajukan.",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((response) => {
        if (response) {
          $('[type=checkbox]').prop("disabled", true);
          var btn = document.getElementById("btnPengajuan");
          btn.disabled = true;
          btn.innerHTML = 'mengajukan sp&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>';

          API_AKADEMIK.post('ajukan/jadwal/krs/akademik/dua/up' + KEY_AKA + '&icmb=' + id_camaba + '&idsem=' + this.state.vmhs.idsem, { check_list: this.state.checkBawah })
            .then(res => {
              if (res.data[0].cekingdata == 1) {
                swal({
                  icon: "success",
                  title: "Berhasil pengajuan",
                  text: "pengajuan mata kuliah sp berhasil.",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshPengajuan()
                })
              }
              else if (res.data[0].cekingdata == '0b') {
                swal({
                  icon: "info",
                  title: "Gagal pengajuan",
                  text: "jumlah sks yang diajukan tidak boleh lebih dari 9.",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshPengajuan()
                })
              }
              else if (res.data[0].cekingdata == '0c') {
                swal({
                  icon: "info",
                  title: "Data sudah ada",
                  text: "mata kuliah sp yang dipilih, telah diajukan",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshPengajuan()
                })
              }
              else {
                swal({
                  icon: "warning",
                  title: "Gagal pengajuan",
                  text: "silahkan coba lagi.",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshPengajuan()
                });
              }
            })
        }
      })
    } else {
      swal({
        icon: "info",
        title: "Tidak ada data terpilih",
        text: "pilih dahulu mata kuliah yang akan diajukan, kemudian klik tombol pengajuan",
      });
    }
  }

  ProcessHapus = () => {
    if (this.state.checkAtas.length != 0) {
      swal({
        title: "Yakin untuk dihapus ?",
        text: "mata kuliah akan dihapus.",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((response) => {
        if (response) {
          $('[type=checkbox]').prop("disabled", true);
          var btn = document.getElementById("btnHapus");
          btn.disabled = true;
          btn.innerHTML = 'menghapus krs&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>';

          API_AKADEMIK.put('hapus/pengajuan/sp/del' + KEY_AKA + '&icmb=' + id_camaba, { check_list: this.state.checkAtas })
            .then(res => {
              if (res.data[0].cekingdata == 1) {
                swal({
                  icon: "success",
                  title: "Berhasil menghapus pengajuan",
                  text: "pengajuan mata kuliah sp berhasil dihapus.",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshHapus();
                })
              }
              else {
                swal({
                  icon: "warning",
                  title: "Gagal dihapus",
                  text: "silahkan coba lagi.",
                  timer: 3000,
                  buttons: false,
                }).then(() => {
                  this.refreshHapus();
                });
              }
            })
        }
      })
    } else {
      swal({
        icon: "info",
        title: "Tidak ada data terpilih",
        text: "pilih dahulu mata kuliah yang akan dihapus, kemudian klik tombol hapus",
      });
    }
  }

  refreshPengajuan = () => {
    // realtime action
    this.getMatkul()
    this.state.checkBawah = [];

    // refresh
    $('[type=checkbox]').prop("disabled", false);
    $('[type=checkbox]').prop("checked", false);
    var btn = document.getElementById("btnPengajuan");
    btn.disabled = false;
    btn.innerHTML = 'pengajuan';
  }

  refreshHapus = () => {
    // realtime action
    this.getMatkul();
    this.state.checkAtas = [];

    // refresh
    $('[type=checkbox]').prop("disabled", false);
    $('[type=checkbox]').prop("checked", false);
    var btn = document.getElementById("btnHapus");
    btn.disabled = false;
    btn.innerHTML = 'hapus';
  }

  componentDidMount = () => {
    this.getDataMhs()
  }

  render() {
    return (
      <div className="smooth mb-2">
        <div className="col-md-12 mb-3">
          <div className="row">
            <div className="col-12 col-xl-8 mb-xl-0">
              <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Semester Pendek
              </p>
            </div>
          </div>
        </div>
        {
          this.state.akses == 1 ?
            <>
              <div className="card card-custom">
                <div className="card-body">
                  <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                    Pengajuan Semester Pendek
                  </p>
                  <div className="table-responsive">
                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td>NIM</td>
                          <td> : </td>
                          <td>{this.state.vmhs.nim}</td>

                          <td>Angkatan</td>
                          <td> : </td>
                          <td>{this.state.vmhs.angkt}</td>
                        </tr>
                        <tr>
                          <td>Nama</td>
                          <td> : </td>
                          <td>{this.state.vmhs.nmmw}</td>

                          <td>Tahun Akademik</td>
                          <td> : </td>
                          <td>{this.state.vmhs.thajara}</td>
                        </tr>
                        <tr>
                          <td>Prodi</td>
                          <td> : </td>
                          <td>{this.state.vmhs.jrsn}</td>
                          <td>Semester</td>
                          <td> : </td>
                          <td>{this.state.vmhs.semester}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br />
                  <br />
                  <p className="card-title" style={{ fontSize: "17px", marginLeft: "0.5%" }}>
                    Mata kuliah SP diajukan :
                  </p>
                  <div className="alert alert-info" role="alert">
                    Pembayaran sudah dapat dilakukan dengan total biaya yang ditentukan, agar MK aktif !
                  </div>
                  <div className="table-responsive mt-3">
                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Kode MK</th>
                          <th>Mata Kuliah</th>
                          <th>SKS Teori</th>
                          <th>SKS Praktek</th>
                          <th>Status</th>
                          <th>
                            <div style={{ display: "flex" }}>
                              <span style={{ marginTop: "-3px" }}>Pilih</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.matkulAtas.length != 0 ? this.state.matkulAtas.map((v, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{v.kodemk}</td>
                              <td>{v.namamk}</td>
                              <td>{v.sksteori}</td>
                              <td>{v.skspraktek}</td>
                              <td>
                                <span className={v.status != 0 ? 'badge badge-success' : 'badge badge-secondary'} style={{ fontSize: '14px' }}>{v.status != 0 ? 'disetujui' : 'diajukan'}</span>
                              </td>
                              <td><input onChange={this.toggleCheckboxAtas} type="checkbox" value={v.kodemk} /></td>
                            </tr>
                          )) : <tr><td colSpan={7} align="center">Tidak Ada Data</td></tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        Total Bayar :
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p align="right">
                        <button className="btn btn-danger" id="btnHapus" onClick={this.ProcessHapus}>
                          hapus
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* mata kuliah pilihan  */}
              <div className="card card-custom mt-3">
                <div className="card-body">
                  <p className="card-title" style={{ fontSize: "16px", marginTop: "10px", marginBottom: "25px", marginLeft: '0.5%' }}>
                    Pilihan Mata Kuliah SP Untuk diajukan :
                  </p>
                  <div className="table-responsive">
                    <table
                      className="display expandable-table tableBord table-striped"
                      style={{ width: "100%" }}
                    >
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td width="150px">Semester saat ini</td>
                          <td> : </td>
                          <td></td>
                          <td width="200px">Maks. SKS SP diajukan</td>
                          <td width="50px"> : </td>
                          <td>9</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="table-responsive mt-3">
                    <table id="MK" className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th data-orderable="false">Kode MK</th>
                          <th data-orderable="false">Mata Kuliah</th>
                          <th data-orderable="false">SKS Teori</th>
                          <th data-orderable="false">SKS Praktek</th>
                          <th>Semester</th>
                          <th data-orderable="false">B/U</th>
                          <th>
                            <div style={{ display: "flex" }}>
                              <span style={{ marginTop: "-3px" }}>Pilih</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.matkulBawah.length != 0 ? this.state.matkulBawah.map((v, index) => (
                            <tr key={index}>
                              <td>{v.kodemk}</td>
                              <td>{v.namamk}</td>
                              <td>{v.sksteori}</td>
                              <td>{v.skspraktek}</td>
                              <td>{v.sem}</td>
                              <td>{v.bu}</td>
                              <td>
                                <input onChange={this.toggleCheckboxBawah} name="checkAtas" type="checkbox" value={v.kodemk} />
                              </td>
                            </tr>
                          )) : <tr><td colSpan={7} align="center">Tidak Ada Data</td></tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <br />
                  <p align="right">
                    <button className="btn btn-success" id="btnPengajuan" onClick={this.ProcessPengajuan}>
                      pengajuan
                    </button>
                  </p>
                </div>
              </div>
              {/* end mata kuliah pilihan  */}
            </>
            :
            <div className="card card-custom">
              <div className="card-body">
                <div style={{ paddingTop: '5%', paddingBottom: '5%' }}>
                  <img src="/lost.svg" alt="lost" style={{
                    width: '200px', display: 'block', marginLeft: 'auto',
                    marginRight: 'auto'
                  }} />
                  <p className="abu" style={{
                    textAlign: 'center', fontSize: '17px', marginTop: '30px',
                    color: '#999999'
                  }}>Semester pendek belum dibuka.
                  </p>
                </div>
              </div>
            </div>
        }
      </div>
    );
  }
}

export default SemesterPendek;
